export const overAdvanceEn = {
  OVER_ADVANCE_CREATED_SUCCESSFULLY: 'Over Advance created successfully',
  FLAT_FEE: 'Flat fee',
  AMORTIZATION: 'Amortization',
  INTEREST_RATE: 'Interest Rate (%)',
  BATCH_RECOVERY_RATE: 'Batch Recovery Rate',
  BATCH_RECOVERY_RATE_TOOLTIP:
    'Autocalculates the chargeback amount from the total invoice amount. ($ Invoice Amount x Recovery Rate %)',
  PAYMENT_PLAN: 'Payment Plan',
  PAYMENT_FREQUENCY: 'Frequency',
  NUMBER_OF_PAYMENTS: 'Number of Payments',
  PAYMENT_START: 'Payment Start',
  FIXED_DATE: 'Fixed Date',
  FUNDING_DATE: 'Funding Date',
  PAYMENT_START_DATE: 'Payment Start Date',
  AMORTIZATION_SCHEDULE: 'Amortization Schedule',
  PAYMENT_NUMBER: '#',
  PAYMENT_DATE: 'Payment Date',
  PAYMENT_AMOUNT: 'Payment Amount',
  PAYMENT_INTEREST: 'Interest',
  PAYMENT_PRINCIPAL: 'Principal',
  PAYMENT_BALANCE: 'Balance',
  TBD_DATE: 'TBD',
  WEEKLY: 'Weekly',
  OVER_ADVANCE_AMOUNT: 'Over Advance Amount',
  OVER_ADVANCE_FEE: 'Fee Amount',
  OVER_ADVANCE_ZERO_INTEREST_WARNING:
    'Interest rate is 0. Amortization schedule will show zero interest.',
  OVER_ADVANCE_NOTES_UPDATED_SUCCESSFULLY: 'Over Advance notes updated successfully',
  OVER_ADVANCE_UPDATED_SUCCESSFULLY: 'Over Advance updated successfully',
  TOTAL_ADVANCE_AMT: 'Total Advance Amt',
  TOTAL_PAID: 'Total Paid',
  TOTAL_OVERALL_BALANCE: 'Total Overall Balance',
  TOTAL_OVER_ADVANCE_AMOUNT: 'Total Over Advance Amount',
  OVER_ADVANCE_BALANCE: 'Over Advance Balance',
  INTEREST_BALANCE: 'Interest Balance',
  MAX_100: 'Max 100',
  MAX_4_DECIMAL_PLACES: 'Max 4 decimal places',
  MAX_50_CHARACTERS: 'Maximum 50 characters allowed',
  SELECTED_OVER_ADVANCES: 'Selected Over Advances',
  CLICK_SELECTED_OVER_ADVANCE_TO_VIEW_INFORMATION: 'Click the selected Over Advance to view information',
  NO_NOTES_REGISTERED_FOR_THIS_OVER_ADVANCE: 'No notes recorded for this Over Advance.',
  APPROVE_FOR_FUNDING_OVER_ADVANCE_CONFIRMATION_TITLE: 'Confirm Approval?',
  APPROVE_FOR_FUNDING_OVER_ADVANCE_CONFIRMATION_BODY: 'all these over advances will be approved for funding once submitted.',
  APPROVE_FOR_FUNDING_OVER_ADVANCE_CONFIRMATION_ALL:
    '{count} over advances will be approved for funding once submitted.',
  APPROVE_FOR_FUNDING_OVER_ADVANCE_CONFIRMATION_GO_BACK: 'Go back',
  APPROVE_FOR_FUNDING_OVER_ADVANCE_CONFIRMATION_APPROVE: 'Yes, Approve',
  DOCUMENTS_OVER_ADVANCE_UPLOADED_SUCCESSFULLY: 'Documents for Over Advance uploaded successfully',
  PLANNED_PAYMENT_UPDATED_SUCCESSFULLY: 'Payment updated successfully',
  PAYMENT_STATUS: 'Status',
  PAYMENT_STATUS_PAID: 'Paid',
  PAYMENT_STATUS_PENDING: 'Pending',
  EDIT_PAYMENT: 'Edit Payment',
  // Over Advance Templates
  OVER_ADVANCE_TEMPLATES: 'Over Advance Templates',
  OVER_ADVANCE_TEMPLATE: 'Over Advance Template',
  CREATE_OVER_ADVANCE_TEMPLATE: 'Create Over Advance Template',
  UPDATE_OVER_ADVANCE_TEMPLATE: 'Update Over Advance Template',
  OVER_ADVANCE_TEMPLATE_CREATED_SUCCESSFULLY: 'Over advance template created successfully',
  OVER_ADVANCE_TEMPLATE_UPDATED_SUCCESSFULLY: 'Over advance template updated successfully',
  DAILY: 'Daily',
  MONTHLY: 'Monthly',
  MANAGE_TEMPLATES: 'Manage Templates',
  BACK: 'Back',
  SELECT_TEMPLATE: 'Select Template (Optional)',
  NO_TEMPLATES_AVAILABLE: 'No templates available',
  REGENERATE_PAYMENT_PLAN: 'Regenerate Payment Plan',
  PAYMENT_PLAN_REGENERATED_SUCCESSFULLY: 'Payment plan regenerated successfully',
  CREATED_ON: 'Created On',
  FUNDED_DATE: 'Funded Date',
  // Write Off Over Advances
  WRITE_OFF_OA_NONE_SELECTED: 'No over advances selected',
  WRITE_OFF_OA_ONE_SELECTED: 'One over advance selected',
  WRITE_OFF_OA_MULTIPLE_SELECTED: '{amount} over advances selected',
  WRITE_OFF_OA_SUCCESS: 'Over advance write off applied successfully',
  WRITE_OFF_OA_CONFIRMATION: 'Are you sure that you want to apply this write off to these over advances?',
  WRITE_OFF_OA_TOTAL_BALANCE: 'Total OA Balance:',
  WRITE_OFF_OA_TOTAL_AMOUNT: 'Total Write Off Amount:',
  WRITE_OFF_OA_OVER_AMOUNT: 'The total write off amount exceeds the total over advance balance.',
  WRITE_OFF_OA_AMOUNT_POSITIVE: 'The write off amount must be greater than 0.',
  WRITE_OFF_OA_PERMISSION_REQUIRED: 'You do not have permission to write off over advances.',
  WRITE_OFF_OA_VALIDATION_MAX: 'Amount must be equal or less than the over advance balance.',
  APPLIED_OVER_ADVANCES: 'Applied Over Advances',
  PARTIAL: 'Partial',
}

export const overAdvanceEs: typeof overAdvanceEn = {
  OVER_ADVANCE_CREATED_SUCCESSFULLY: 'Over Advance creado con éxito',
  FLAT_FEE: 'Tarifa fija',
  AMORTIZATION: 'Amortización',
  INTEREST_RATE: 'Tasa de Interés (%)',
  BATCH_RECOVERY_RATE: 'Tasa de Recuperación del Lote',
  BATCH_RECOVERY_RATE_TOOLTIP:
    'Calcula automáticamente el monto del chargeback a partir del monto total de la factura. ($ Monto de Factura x Tasa de Recuperación %)',
  PAYMENT_PLAN: 'Plan de Pago',
  PAYMENT_FREQUENCY: 'Frecuencia',
  NUMBER_OF_PAYMENTS: 'Número de Pagos',
  PAYMENT_START: 'Inicio de Pagos',
  FIXED_DATE: 'Fecha Fija',
  FUNDING_DATE: 'Fecha de Fondeo',
  PAYMENT_START_DATE: 'Fecha de Inicio',
  AMORTIZATION_SCHEDULE: 'Tabla de Amortización',
  PAYMENT_NUMBER: '#',
  PAYMENT_DATE: 'Fecha de Pago',
  PAYMENT_AMOUNT: 'Monto de Pago',
  PAYMENT_INTEREST: 'Interés',
  PAYMENT_PRINCIPAL: 'Capital',
  PAYMENT_BALANCE: 'Saldo',
  TBD_DATE: 'Por definir',
  WEEKLY: 'Semanal',
  OVER_ADVANCE_AMOUNT: 'Monto de Over Advance',
  OVER_ADVANCE_FEE: 'Monto de la tarifa',
  OVER_ADVANCE_ZERO_INTEREST_WARNING:
    'La tasa de interés es 0. La tabla de amortización mostrará interés 0.',
  OVER_ADVANCE_NOTES_UPDATED_SUCCESSFULLY: 'Notas de Over Advance actualizadas con éxito',
  OVER_ADVANCE_UPDATED_SUCCESSFULLY: 'Over Advance actualizado con éxito',
  TOTAL_ADVANCE_AMT: 'Monto total del adelanto',
  TOTAL_PAID: 'Total pagado',
  TOTAL_OVERALL_BALANCE: 'Saldo total general',
  TOTAL_OVER_ADVANCE_AMOUNT: 'Monto total de Over Advance',
  OVER_ADVANCE_BALANCE: 'Saldo de Over Advance',
  INTEREST_BALANCE: 'Saldo de interés',
  MAX_100: 'Máximo 100',
  MAX_4_DECIMAL_PLACES: 'Máximo 4 decimales',
  MAX_50_CHARACTERS: 'Máximo 50 caracteres permitidos',
  SELECTED_OVER_ADVANCES: 'Over Advances seleccionados',
  CLICK_SELECTED_OVER_ADVANCE_TO_VIEW_INFORMATION: 'Haz clic en un Over Advance para ver su información',
  NO_NOTES_REGISTERED_FOR_THIS_OVER_ADVANCE: 'No hay notas registradas para este Over Advance.',
  APPROVE_FOR_FUNDING_OVER_ADVANCE_CONFIRMATION_TITLE: '¿Confirmar aprobación?',
  APPROVE_FOR_FUNDING_OVER_ADVANCE_CONFIRMATION_BODY:
    'todos estos over advances serán aprobados para financiamiento una vez enviados.',
  APPROVE_FOR_FUNDING_OVER_ADVANCE_CONFIRMATION_ALL:
    '{count} over advances serán aprobados para financiamiento una vez enviados.',
  APPROVE_FOR_FUNDING_OVER_ADVANCE_CONFIRMATION_GO_BACK: 'Regresar',
  APPROVE_FOR_FUNDING_OVER_ADVANCE_CONFIRMATION_APPROVE: 'Sí, aprobar',
  DOCUMENTS_OVER_ADVANCE_UPLOADED_SUCCESSFULLY: 'Documentos para Over Advance cargados correctamente',
  PLANNED_PAYMENT_UPDATED_SUCCESSFULLY: 'Pago actualizado correctamente',
  PAYMENT_STATUS: 'Estado',
  PAYMENT_STATUS_PAID: 'Pagado',
  PAYMENT_STATUS_PENDING: 'Pendiente',
  EDIT_PAYMENT: 'Editar Pago',
  // Over Advance Templates
  OVER_ADVANCE_TEMPLATES: 'Plantillas de Over Advance',
  OVER_ADVANCE_TEMPLATE: 'Plantilla de Over Advance',
  CREATE_OVER_ADVANCE_TEMPLATE: 'Crear Plantilla de Over Advance',
  UPDATE_OVER_ADVANCE_TEMPLATE: 'Actualizar Plantilla de Over Advance',
  OVER_ADVANCE_TEMPLATE_CREATED_SUCCESSFULLY: 'Plantilla de Over Advance creada con éxito',
  OVER_ADVANCE_TEMPLATE_UPDATED_SUCCESSFULLY: 'Plantilla de Over Advance actualizada con éxito',
  DAILY: 'Diario',
  MONTHLY: 'Mensual',
  MANAGE_TEMPLATES: 'Administrar Plantillas',
  BACK: 'Regresar',
  SELECT_TEMPLATE: 'Seleccionar Plantilla (Opcional)',
  NO_TEMPLATES_AVAILABLE: 'No hay plantillas disponibles',
  REGENERATE_PAYMENT_PLAN: 'Regenerar Plan de Pago',
  PAYMENT_PLAN_REGENERATED_SUCCESSFULLY: 'Plan de pago regenerado con éxito',
  CREATED_ON: 'Fecha de Creación',
  FUNDED_DATE: 'Fecha de Fondeo',
  // Write Off Over Advances
  WRITE_OFF_OA_NONE_SELECTED: 'Ningún over advance seleccionado',
  WRITE_OFF_OA_ONE_SELECTED: 'Un over advance seleccionado',
  WRITE_OFF_OA_MULTIPLE_SELECTED: '{amount} over advances seleccionados',
  WRITE_OFF_OA_SUCCESS: 'Write off de over advance aplicado correctamente',
  WRITE_OFF_OA_CONFIRMATION: '¿Está seguro que desea aplicar este Write Off a estos over advances?',
  WRITE_OFF_OA_TOTAL_BALANCE: 'Saldo total OA:',
  WRITE_OFF_OA_TOTAL_AMOUNT: 'Monto total de Write Off:',
  WRITE_OFF_OA_OVER_AMOUNT: 'El monto total del write off excede el saldo total del over advance.',
  WRITE_OFF_OA_AMOUNT_POSITIVE: 'El monto del write off debe ser mayor a 0.',
  WRITE_OFF_OA_PERMISSION_REQUIRED: 'No tienes permiso para aplicar write offs a over advances.',
  WRITE_OFF_OA_VALIDATION_MAX: 'El monto debe ser igual o menor al saldo del over advance.',
  APPLIED_OVER_ADVANCES: 'Over Advances aplicados',
  PARTIAL: 'Parcial',
}
